var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIconV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26786 0C9.12879 0 9.82143 0.691042 9.82143 1.55V4.13333H20.1786V1.55C20.1786 0.691042 20.8712 0 21.7321 0C22.5931 0 23.2857 0.691042 23.2857 1.55V4.13333H25.3571C27.6422 4.13333 29.5 5.98688 29.5 8.26667V26.8667C29.5 29.1465 27.6422 31 25.3571 31H4.64286C2.35781 31 0.5 29.1465 0.5 26.8667V8.26667C0.5 5.98688 2.35781 4.13333 4.64286 4.13333H6.71429V1.55C6.71429 0.691042 7.40692 0 8.26786 0ZM8.26786 7.23333H4.64286C4.07321 7.23333 3.60714 7.69833 3.60714 8.26667V26.8667C3.60714 27.435 4.07321 27.9 4.64286 27.9H25.3571C25.9268 27.9 26.3929 27.435 26.3929 26.8667V8.26667C26.3929 7.69833 25.9268 7.23333 25.3571 7.23333H8.26786ZM9.82143 16.5333V21.7H20.1786V16.5333H9.82143ZM6.71429 16.5333C6.71429 14.8219 8.10603 13.4333 9.82143 13.4333H20.1786C21.894 13.4333 23.2857 14.8219 23.2857 16.5333V21.7C23.2857 23.4115 21.894 24.8 20.1786 24.8H9.82143C8.10603 24.8 6.71429 23.4115 6.71429 21.7V16.5333Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconV2);
export default __webpack_public_path__ + "static/media/calendar-icon-v2.2db94f71b3f00e65d6f25c1cf8a495e7.svg";
export { ForwardRef as ReactComponent };